import { createContext } from "react";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { DEFAULT_FUNCTION } from "../../utils/helpers/constants";
import {IApps, IAppDetails} from "../../models/apps/response";
import {IUpdateMessageApp} from "../../models/apps/request";

export type AppsLoading = "list" | "update" ;

export interface IInternalState {
  loading: AppsLoading[];

  list?: any;

  details?: IAppDetails;
}

export const internalState: IInternalState = {
  loading: [],
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    updateMessageApp: (id: number, request: FormData) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    updateMessageApp: DEFAULT_FUNCTION,
  },
};

const AppsContext = createContext(externalState);

export default AppsContext;
